import axios from 'axios';
import axiosRetry from 'axios-retry';
import domains from './global';
const axiosMockClient = axios.create({
    baseURL: domains.url,
    timeout: 120000,
});
export const axiosAuthClient = axios.create({
    baseURL: `${domains.auth}/api`,
    timeout: 60000,
});
axiosMockClient.interceptors.request.use(
// @ts-ignore
(config) => {
    const accessToken = window.sessionStorage.getItem('auth_token');
    if (!accessToken)
        return config;
    return (Object.assign(Object.assign({}, config), { headers: Object.assign(Object.assign({}, config.headers), { Authorization: `Bearer ${accessToken}`, Accept: 'application/json' }) }));
}, (error) => Promise.reject(error));
const verifyRefreshToken = async (originalRequest, axiosResponse) => {
    var _a;
    const refreshToken = window.localStorage.getItem('auth_refresh');
    /* Get new token by using the refresh token */
    if (refreshToken) {
        try {
            const { data } = await axiosAuthClient.post('/api/auth/refresh_token', { refresh_token: refreshToken });
            window.sessionStorage.setItem('auth_token', data.data.token);
            window.localStorage.setItem('auth_refresh', data.data.refresh_token);
            axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
            return await axiosMockClient(originalRequest);
        }
        catch (err) {
            document.location.assign(`${domains.auth}?redirect=${window.location.href}`);
        }
        return Promise.reject(new Error((_a = axiosResponse.data) === null || _a === void 0 ? void 0 : _a.msg));
    }
    /* no refresh token, user need to log in */
    document.location.assign(`${domains.auth}?redirect=${window.location.href}`);
    return null;
};
const handleResponse = async (axiosResponse) => {
    var _a, _b;
    const originalRequest = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.config;
    /* Token invalid */
    if (((axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.status) === 401 || (((_a = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _a === void 0 ? void 0 : _a.status) === 'KO' && ((_b = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _b === void 0 ? void 0 : _b.code) === '401'))
        // @ts-ignore
        && !originalRequest.retry) {
        // @ts-ignore
        originalRequest.retry = true;
        await verifyRefreshToken(originalRequest, axiosResponse);
    }
    return axiosResponse;
};
const handleError = async (axiosError) => {
    var _a, _b;
    const originalRequest = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.config;
    /* Token invalid */
    // eslint-disable-next-line no-underscore-dangle
    if (((_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.status) === 401 && !originalRequest._retry) {
        // eslint-disable-next-line no-underscore-dangle
        originalRequest._retry = true;
        await verifyRefreshToken(originalRequest, axiosError.response);
    }
    return Promise.reject(axiosError);
};
axiosMockClient.interceptors.response.use(handleResponse, (error) => handleError(error));
axiosRetry(axiosMockClient, {
    retries: 2,
    shouldResetTimeout: true,
    retryCondition: (error) => {
        const isTimeout = error.code === 'ECONNABORTED';
        const isServerError = error.response && error.response.status >= 500 || false;
        return isTimeout || isServerError;
    },
    retryDelay: (retryCount) => retryCount * 1000,
});
export default axiosMockClient;
